import { createSlice } from '@reduxjs/toolkit';
import { IMdbError } from '../../../errorObjects/MdbError';

const initialState: IMdbError | null = null;

export const userFeedbackDeleteFailureSlice = createSlice({
  name: 'userFeedbackDeleteFailure',
  initialState,
  reducers: {
    // action has a payload with an error
    userFeedbackDeleteFailureChange(state, action) {
      return action.payload;
    },
        
    // action has a payload with a null value
    userFeedbackDeleteFailureClear(state) {
      return null;
    },
  },
})

// Action creators are generated for each function in reducer)
export const { userFeedbackDeleteFailureChange, userFeedbackDeleteFailureClear } = userFeedbackDeleteFailureSlice.actions;

// export the core reducer for the slice
export const userFeedbackDeleteFailureReducer = userFeedbackDeleteFailureSlice.reducer;

export default userFeedbackDeleteFailureSlice.reducer;